import {getCommonConfigKey} from "@a";
export default {
  data () {
    return {
      /** 夜间时间 */
      nightTime: []
    }
  },
  mounted () {
    getCommonConfigKey({ paramName: 'NIGHT_ORDER_TIME' }).then(({ data }) => {
      this.nightTime = JSON.parse(data.paramValue)
    })
  },
  computed: {
    timeIsNight () {
      const now = new Date()
      const hour = now.getHours()
      const minute = now.getMinutes()
      const time = hour * 60 + minute
      /** 大的时间为开始时间 开始时间为第一天 */
      const nightStart = this.nightTime?.[0] || 1230
      /** 小的时间为结束时间 结束时间为第二天 */
      const nightEnd = this.nightTime?.[1] || 510

      return time <= nightEnd || time >= nightStart
    }
  }
}
